import allSchoolCalendar from "./AllSchoolCalendar";
import athleticsCalendar from "./AthleticsCalendar";
import TeamCalendar from "./TeamCalendar";
import AlumniCalendar from "./AlumniCalendar";

document.addEventListener("DOMContentLoaded", function () {
  let today = new Date();
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  let yyyy = today.getFullYear();

  allSchoolCalendar(yyyy + "-" + mm + "-" + dd);
  athleticsCalendar(yyyy + "-" + mm + "-" + dd);
  TeamCalendar(yyyy + "-" + mm + "-" + dd);
  AlumniCalendar(yyyy + "-" + mm + "-" + dd);
});
